module.exports = __webpack_public_path__ + "img/pc_banner_terms.3d54da7e.jpeg";